import { useAppState } from 'lib/appState'

export function useOrganizationSupporters(organizationApikey, componentName) {
  const {
    appAction,
    supporters,
    loadingSupporters,
    supportersError,
    pagination,
  } = useAppState(
    {
      [`organization:${organizationApikey}:supporters`]: 'supporters',
      [`organization:${organizationApikey}:supporters:loading`]: 'loadingSupporters',
      [`organization:${organizationApikey}:supporters:error`]: 'supportersError',
      [`organization:${organizationApikey}:supporters:pagination`]: 'pagination',
    },
    componentName,
  )

  const loadSupportersAction = appAction('organizationSupport.loadSupporters', organizationApikey)
  const clearError = appAction('organizationSupport.clearSupportError', organizationApikey, 'supporters')

  const loadSupporters = (page = 1, limit = 50) => {
    loadSupportersAction(page, limit)
  }

  return {
    supporters: supporters || [],
    loadingSupporters,
    supportersError,
    pagination: pagination || { page: 1, total: 0, totalPages: 0 },
    loadSupporters,
    clearError,
  }
}

export function useOrganizationSupport(organizationApikey, componentName) {
  const {
    appAction,
    creatingCheckout,
    checkoutError,
    supportStatus,
    loadingStatus,
    statusError,
  } = useAppState(
    {
      [`organization:${organizationApikey}:support:creatingCheckout`]: 'creatingCheckout',
      [`organization:${organizationApikey}:support:creatingCheckoutError`]: 'checkoutError',
      [`organization:${organizationApikey}:support:status`]: 'supportStatus',
      [`organization:${organizationApikey}:support:status:loading`]: 'loadingStatus',
      [`organization:${organizationApikey}:support:status:error`]: 'statusError',
    },
    componentName,
  )

  const createCheckout = appAction('organizationSupport.createSupportCheckout', organizationApikey)
  const checkStatus = appAction('organizationSupport.checkSupportStatus', organizationApikey)
  const clearCheckoutError = appAction('organizationSupport.clearSupportError', organizationApikey, 'creatingCheckout')
  const clearStatusError = appAction('organizationSupport.clearSupportError', organizationApikey, 'status')

  const createCheckoutWithAmount = (amountCents) => {
    createCheckout(amountCents)
  }

  return {
    createCheckout: createCheckoutWithAmount,
    creatingCheckout,
    checkoutError,
    supportStatus,
    loadingStatus,
    statusError,
    checkStatus,
    clearCheckoutError,
    clearStatusError,
  }
}

export function useMySupportedHubs(componentName) {
  const {
    appAction,
    supportedHubs,
    loading,
    error,
  } = useAppState(
    {
      'mySupportedHubs': 'supportedHubs',
      'mySupportedHubs:loading': 'loading',
      'mySupportedHubs:error': 'error',
    },
    componentName,
  )

  const loadSupportedHubs = appAction('organizationSupport.loadMySupportedHubs')
  const cancelSupport = appAction('organizationSupport.cancelHubSupport')

  const useGetCancellingState = (supportId) => {
    const state = useAppState(
      {
        [`mySupportedHubs:cancelling:${supportId}`]: 'cancelling',
        [`mySupportedHubs:cancelling:${supportId}Error`]: 'cancelError',
      },
      componentName,
    )
    return {
      cancelling: state.cancelling,
      cancelError: state.cancelError,
    }
  }

  return {
    supportedHubs: supportedHubs || [],
    loading,
    error,
    loadSupportedHubs,
    cancelSupport,
    useGetCancellingState,
  }
}
